export default __webpack_public_path__ + "static/media/upload-banner.c6c99531.png";